import { PropTypes } from 'prop-types';

const Note = ({ label, data }) => {
  const element = document.createElement('div');
  element.innerHTML = data;

  if (!data || element.innerText === '') return null;

  return (
    <div className="w-100 flex flex-column items-start justify-between">
      <div className="w-100">
        <span className="apps-grid-title">{label}</span>

        <p
          className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2"
          dangerouslySetInnerHTML={{
            __html: data,
          }}
        ></p>
      </div>
    </div>
  );
};

Note.propTypes = {
  label: PropTypes.string,
  data: PropTypes.string,
};

export default Note;
